// Filter only clearly labelled style specifications; shared prose stays visible.
function initializeClothingStyleDetails(root, description) {
  const normalize = value => value.toLowerCase().replace(/[^a-z0-9]/g, '');
  const styleField = () => [...root.querySelectorAll('variant-selects fieldset')].find(field => /^styles?$/i.test(field.querySelector('legend')?.textContent.trim() || ''));
  const field = styleField();
  if (!description || !field) return;
  const styles = new Set([...field.querySelectorAll('input[type="radio"]')].map(input => normalize(input.value)));
  const groups = [];
  // Legacy descriptions can wrap specifications inside a details panel.
  [...description.querySelectorAll('p, h2, h3, h4, h5, h6')].forEach(heading => {
    const key = normalize(heading.textContent.trim());
    if (!styles.has(key)) return;
    const nodes = [heading];
    let next = heading.nextElementSibling;
    while (next && (next.matches('ul, ol, table') || /^[•●▪]/.test(next.textContent.trim()))) {
      nodes.push(next);
      next = next.nextElementSibling;
    }
    // Leave unfamiliar content intact rather than guessing section boundaries.
    if (nodes.length > 1) groups.push({ key, nodes });
  });
  const update = () => {
    const selected = normalize(styleField()?.querySelector('input:checked')?.value || '');
    const hasMatch = groups.some(group => group.key === selected);
    groups.forEach(group => group.nodes.forEach(node => { node.hidden = hasMatch && group.key !== selected; }));
  };
  root.addEventListener('change', update);
  const picker = root.querySelector('variant-selects');
  if (picker) new MutationObserver(update).observe(root, { childList: true, subtree: true });
  update();
}

function initializeClothing(root) {
  if (root.dataset.clothingInitialized) return;
  root.dataset.clothingInitialized = 'true';
  const description = root.querySelector('.clothing-product__description');
  initializeClothingStyleDetails(root, description);
  const dialog = root.querySelector('.clothing-size-dialog');
  if (!dialog) return;
  const tables = [...(description?.querySelectorAll('table') || [])].filter(table => /length|width|chest|waist|sleeve|bust|hips|inches|centimeters/i.test(table.textContent));
  const content = dialog.querySelector('[data-clothing-size-content]');
  // Use the product's own measurements, never the old one-chart-for-every-garment fallback.
  tables.forEach(table => {
    const clone = table.cloneNode(true);
    clone.removeAttribute('id');
    clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
    const rows = [...clone.rows];
    rows.forEach((row, index) => [...row.cells].forEach((cell, column) => {
      if (index !== 0 && column !== 0) return;
      const heading = document.createElement('th');
      heading.scope = index === 0 ? 'col' : 'row';
      heading.innerHTML = cell.innerHTML;
      if (!heading.textContent.trim()) heading.textContent = 'Size';
      cell.replaceWith(heading);
    }));
    content.append(clone);
  });
  const guideTitle = tables.length ? 'Size guide' : 'How to measure';
  dialog.querySelector('[data-clothing-size-title]').textContent = guideTitle;
  dialog.setAttribute('aria-label', guideTitle);
  const revealGuide = () => root.querySelectorAll('[data-clothing-size-open]').forEach(button => { button.hidden = false; if (button.textContent !== guideTitle) button.textContent = guideTitle; });
  revealGuide();
  const picker = root.querySelector('variant-selects');
  if (picker) new MutationObserver(revealGuide).observe(root, { childList:true, subtree:true });
  let opener;
  root.addEventListener('click', event => {
    const button = event.target.closest('[data-clothing-size-open]');
    if (button) {
      opener = button;
      dialog.showModal();
      dialog.querySelector('button').focus();
    }
    if (event.target.closest('[data-clothing-size-close]')) dialog.close();
  });
  dialog.addEventListener('close', () => opener?.focus());
  if (!tables.length && picker && [...picker.querySelectorAll('legend')].some(el => /size/i.test(el.textContent))) {
    const help = document.createElement('p');
    help.className = 'book-product__policies';
    const link = document.createElement('a');
    link.href = 'mailto:orders@shopcatalog.com';
    link.textContent = 'Need help choosing a size? Contact us';
    help.append(link);
    picker.after(help);
  }
}
document.querySelectorAll('.clothing-product').forEach(initializeClothing);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.clothing-product').forEach(initializeClothing));
